// home category boxes
$('.topCatsMenu > ul > li > a').each(function () {
  $(this).next().append('<li class="viewAll"><a href="#">View All <svg data-name="Layer 1" viewBox="0 0 27.98 14.59" width="18" height="10"><path d="M19.94.3a1 1 0 0 0 0 1.41l4.6 4.6H1a1 1 0 0 0 0 2h23.52l-4.58 4.57a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l6.36-6.36a.89.89 0 0 0 0-1.25L21.36.3A1 1 0 0 0 20 .29Z" data-name="Layer 2"/></a></li>');
  $(this).next().find($('.viewAll a').attr('href', $(this).attr('href')));
  $(this).wrapInner('<h2></h2>');
  $(this).prependTo($(this).next());
});

$('.topCatsMenu .catboxBg img').each(function () {
  $(this).prependTo($(this).closest('.has-submenu'));
});
